import { createFileRoute, Link } from "@tanstack/react-router";
import { POSTS } from "@/data/posts";
import { useReveal } from "@/hooks/use-reveal";
import { PageHero } from "@/components/page-hero";
import heroImg from "@/assets/dj-mariage-services.jpg";
import { metaDesc } from "@/lib/seo-description";

import { ReviewsProof } from "@/components/reviews-proof";
export const Route = createFileRoute("/actualites/")({
  head: () => ({
    meta: [
      { title: "Actualités & conseils DJ mariage | DJ Val" },
      {
        name: "description",
        content:
          metaDesc("Conseils, tendances et retours d'expérience d'un DJ pro en Provence : choisir son DJ, tarifs, ambiances, matériel, témoignages.")
      },
      { property: "og:title", content: "Actualités & Conseils DJ Mariage Provence" },
      { property: "og:description", content: metaDesc("Articles, tendances et conseils du DJ Val pour vos mariages et soirées.") },
      { property: "og:url", content: "https://dj-val.fr/actualites" },
    ],
    links: [{ rel: "canonical", href: "https://dj-val.fr/actualites" }],
  }),
  component: Page,
});

function Page() {
  useReveal();
  const [hero, ...rest] = POSTS;

  return (
    <div className="bg-background text-muted-foreground">
      <PageHero
        image={heroImg}
        eyebrow="Le blog"
        title={<>Actualités <span className="italic">&amp; conseils</span></>}
        subtitle="Tendances, retours d'expérience, conseils pratiques : tout ce qui se passe dans la tête d'un DJ pro en Provence."
        height="compact"
      />
      <ReviewsProof />


      <section className="py-16 px-6 max-w-7xl mx-auto">
        <Link to="/actualites/$slug" params={{ slug: hero.slug }} className="group block sr border border-foreground/10 bg-card overflow-hidden md:grid md:grid-cols-2" data-reveal>
          <div className="aspect-[4/3] md:aspect-auto overflow-hidden">
            <img loading="lazy" decoding="async" src={hero.cover} alt={hero.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
          </div>
          <div className="p-10 flex flex-col justify-center">
            <p className="eyebrow text-foreground">{hero.category} · {hero.readTime}</p>
            <h2 className="font-serif-display text-3xl md:text-4xl text-foreground mt-3 group-hover:text-foreground transition-colors">{hero.title}</h2>
            <span className="gold-rule !w-8 my-5" />
            <p className="text-sm text-muted-foreground leading-relaxed font-light">{hero.excerpt}</p>
            <p className="mt-6 text-[10px] uppercase tracking-[0.25em] text-foreground">Lire l'article →</p>
          </div>
        </Link>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 mt-12">
          {rest.map((p, i) => (
            <Link key={p.slug} to="/actualites/$slug" params={{ slug: p.slug }} className="group sr border border-foreground/10 bg-card overflow-hidden block" data-reveal style={{ transitionDelay: `${(i % 3) * 80}ms` }}>
              <div className="aspect-[4/3] overflow-hidden">
                <img loading="lazy" decoding="async" src={p.cover} alt={p.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-700" />
              </div>
              <div className="p-6">
                <p className="eyebrow text-foreground text-[10px]">{p.category} · {p.readTime}</p>
                <h3 className="font-serif-display text-xl text-foreground mt-2 group-hover:text-foreground transition-colors leading-snug">{p.title}</h3>
                <span className="gold-rule !w-8 my-3" />
                <p className="text-sm text-muted-foreground leading-relaxed font-light line-clamp-3">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
